<div class="snickers-page-container">
    <div class="container">
      <div class="text">
        <div class="section">
          <h1>
            Registration <span class="red"> Regulations</span>
          </h1>
          <div class="block">
            <div class="block-inner">
              <h2>R1.Registration Terms:</h2>
              <ul>
                <li><span class="red">R1.1</span> Registration will begin from (Registration Start Date) to
                  (Registration
                  End Date).
                </li>
                <li><span class="red">R1.2 </span>This tournament is only open for the GCC - Countries: Bahrain, Kuwait,
                  Oman, Qatar, Saudi Arabia, and the United Arab Emirates.
                </li>
                <li><span class="red">R1.3 </span>All participants must be at least (Minimum age) to register for this
                  tournament. (Age Limit?)
                </li>
              </ul>
            </div>

            <div class="block-inner">
              <h2>R2.Registration Equipment:</h2>
              <ul>
                <li><span class="red">R2.1</span> All participants must have a stable internet connection.</li>
                <li><span class="red">R2.2 </span>All participants must have the game installed before the tournament
                  day.
                </li>
                <li><span class="red">R2.3</span>All participants must have an active PS+ subscription on the user which
                  they will play from.
                </li>
                <li><span class="red">R2.4</span>This tournament is set to be played from PS4s only, PS5 with back
                  compatibility isn’t allowed.
                </li>
              </ul>
            </div>
          </div>

          <div class="block">
            <div class="block-inner">
              <h2>R3.Registration Required Info:</h2>
              <ul>
                <li><span class="red">R3.1</span>Required for registration: First and last name, PSN ID, Mobile Number,
                  Discord ID, Age.
                </li>
                <li><span class="red">R3.2 </span>Required in case of qualification: Address.</li>
              </ul>
            </div>
            <div class="block-inner">
              <h2>R4.Proof OF Residency:</h2>
              <ul>
                <li><span class="red">R4.1</span>TO BE ADDED</li>
              </ul>
            </div>
          </div>
        </div>

        <div class="section">
          <h1>
            Game Play <span class="red"> Settings</span>
          </h1>

          <ul>
            <li><span class="red">Mode</span> myClub</li>
            <li><span class="red">Server</span> myClub-EU-01-AR > Lobby: AR-01</li>
            <li>Create a room and share its name and password with your opponent on the Match Chat on GBarena.</li>
            <li>Player on the right side of the match page will create the room.</li>
          </ul>

          <div class="block">
            <div class="block-inner">
              <h2>Match Room Settings:</h2>
              <ul>
                <li><span class="red">Room Name:</span> GB + Match Number from the match page - Example: GB 233.</li>
                <li><span class="red">Room Password:</span> Enable Password.</li>
                <li><span class="red">Password:</span> Random 6 numbers, and make sure to send them on the match chat
                  for your
                  opponent on GBarena.
                </li>
              </ul>
            </div>
            <div class="block-inner">
              <h2>General Match Settings:</h2>
              <ul>
                <li><span class="red">Match time:</span> 12 minutes.</li>
                <li><span class="red">Injuries:</span> On.</li>
                <li><span class="red">Ball Type:</span> Memento.</li>
                <li><span class="red">Time Limit:</span> Normal.</li>
                <li><span class="red">Overtime:</span> On.</li>
                <li><span class="red">PK (Penalty Kicks):</span> On.</li>
                <li><span class="red">Max. No. of Substitution:</span> 3 (+1 in Extra Time).</li>
              </ul>
            </div>
          </div>

          <div class="block-inner">
            <h2>Important Gameplay Notes:</h2>
            <ul>
              <li>All Matches <span class="red">MUST</span> be recorded (Click here for more info about how to record on
                your PS machine) - Admins will ask you for the match gameplay video before approving and submitting your
                score, even if it was confirmed by the opponent. We use the records to check the gameplay and for the
                player ranking and highlights.
              </li>
              <li>Players will need to have discord installed on their phones or other devices with a usable microphone.
                Players can use discord text or voice to for the pre tournament support or for reporting any general
                tournament related issues. Also tournament staff may request to have a Discord call with you.
              </li>
              <li>Chat only with your opponent on the match chat which can be found on GBarena, any other messages won’t
                stand and won’t be counted as proofs.
              </li>
              <li><span class="red">
            [Important] Disconnections: in case of disconnecting, players will need to raise a match issue to notify the tournament staff, players will need to provide a video recording from the game before the disconnections. Players will be instructed to resume the match from the disconnecting time with the scored goals and more details will be added by the admin.
          </span></li>

              <li>Players who qualify must be ready to stream, We can provide full support if it's needed</li>
            </ul>
          </div>
        </div>

        <!--        Third Section -->
        <div class="section">
          <h1>
            Tournament<span class="red"> Flow</span>
          </h1>
          <div class="block">
            <div class="block-inner">
              <h2>TF1. Tournament Stages:</h2>
              <ul>
                <li><span class="red">First Stage - Registration:</span> From (Date) to (Date).</li>
                <li><span class="red">Second Stage -  Qualifiers: </span> From (Date) to (Date).</li>
                <li><span class="red">Third Stage - Finals: </span> From (Date) to (Date).</li>

              </ul>
            </div>

            <div class="block-inner">
              <h2>TF2. Tournament Day:</h2>
              <ul>
                <li><span class="red">TF2.1 </span> (Tournament Days) - (Tournament Hour)</li>
                <li><span class="red">TF2.2 </span> Players will have 10 minutes to set the match up with their
                  opponents.
                </li>
                <li><span class="red">TF2.3 </span> Players will have an extra 10 minutes to report any match related
                  issues.
                </li>
                <li><span class="red">TF2.4 </span> After the first 20 minutes if no issues got reported and the match
                  didn’t start, it may be counted as a double-loss.
                </li>
              </ul>
            </div>
          </div>
          <div class="block-inner">
            <h2>TF3. Match Flow:</h2>
            <ul>
              <li>Players will be notified by their match from the My Match menu, our mobile app or by clicking on it on
                the brackets.
              </li>
              <li>Players will get added to the match chat and they will be able to chat with their opponents using that
                chat.
              </li>
              <li>After completing the match, players will be asked tp upload the gameplay recording from their own
                perspective for the admins to review.
              </li>
              <li>Players will claim the score and will need to upload a score screenshot while claiming it.
                After the recording review the admin will confirm the score.
              </li>
              <li>
                Players will be notified about their next match and will start again from the first step.
              </li>
            </ul>
          </div>

        </div>

<!--        Fourth Section-->
        <div class="section">
          <h1>
            General Tournament<span class="red"> Regulations:</span>
          </h1>
          <div class="block-inner">
            <h2>GTR1. Player Attitude:</h2>
            <ul>
              <li>Only Arabic and English language are allowed.</li>
              <li>Players are only allowed to play with the registered names (PSN IDS), using a different account/name
                may lead to a disqualification.
              </li>
              <li>Respect your opponents, and the staff members.</li>
              <li>Show on time for your matches.</li>
              <li>Notify the organizer whenever you need or require any assistance.</li>
              <li>Provide accurate information while registering for the tournament.
              </li>
            </ul>
          </div>

        </div>

      </div>
    </div>
</div>


